import { render, staticRenderFns } from "./selesai-sipm.vue?vue&type=template&id=4c3a2f86&"
import script from "./selesai-sipm.vue?vue&type=script&lang=js&"
export * from "./selesai-sipm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports